import {InvoiceSchema} from "mock/invoiceSchema.ts";


type ArrayInvoiceInfo = [
    id: string,
    issueDate: string,
    number: string,
    TotalWithoutTax: number,
    TotalWithTax: number,
    status: "PAID" | "UNPAID" | "IN_PROGRESS",
    entity_id: string
]

const invoicesDataMockBase: Array<ArrayInvoiceInfo> = [
    ["1", "2024-01-27", "874CE1FEEH1964", 26.65, 36.77, "PAID", "1"],
    ["2", "2024-01-17", "045BB4CAA17180", 74.92, 88.32, "IN_PROGRESS", '1'],
    ["3", "2023-09-24", "321GR9BTRU8711", 127.92, 139.24, "UNPAID", '1'],
    ["4", "2024-01-26", "871CE18FEH2321", 1.92, 3.24, "UNPAID", '1'],
    ["5", "2024-01-12", "831IJ32NON0192", 45.92, 88.32, "IN_PROGRESS", '1'],
    ["6", "2023-12-31", "061YF86BEV9183", 46.85, 56.97, "PAID", '1'],
    ["7", "2023-10-05", "023OJ71CDZ7890", 10.83, 20.95, "PAID", '1'],
    ["8", "2024-02-17", "431OV34VER0000", 50.92, 64.32, "IN_PROGRESS", '2'],
    ["8", "2024-02-17", "431OV23VER0000", 50.92, 64.32, "IN_PROGRESS", '1'],
    ["9", "2021-12-17", "431OV34VER0001", 56.92, 71.32, "PAID", '1'],
    ["10", "2022-08-17", "431OV34VER0002", 12.22, 15.32, "PAID", '2'],
    ["11", "2023-01-17", "431OV34VER0003", 91.92, 101.32, "UNPAID", '1'],
    ["12", "2024-01-02", "671HE55FAR5555", 199.92, 305.24, "UNPAID", '2'],
    ["13", "2023-11-31", "161YF86BEV9183", 46.85, 56.97, "PAID", '2'],
    ["14", "2023-10-31", "261YF86BEV9183", 44.85, 54.97, "UNPAID", '2'],
    ["15", "2023-09-31", "361YF86BEV9183", 45.85, 55.97, "UNPAID", '2'],
    ["16", "2023-08-31", "461YF86BEV9183", 47.85, 57.97, "PAID", '2'],
    ["17", "2023-07-31", "561YF86BEV9183", 48.85, 58.97, "PAID", '2'],
    ["18", "2023-06-31", "661YF86BEV9183", 41.85, 51.97, "IN_PROGRESS", '2'],
    ["19", "2023-05-31", "761YF86BEV9183", 42.85, 52.97, "PAID",  '2'],
    ["20", "2023-04-31", "861YF86BEV9183", 43.85, 53.97, "IN_PROGRESS", '2'],
    ["21", "2023-03-31", "961YF86BEV9183", 49.85, 59.97, "PAID", '2'],

]

const createInvoiceObject = (arr: ArrayInvoiceInfo): InvoiceSchema => {
    return {
        id: arr[0],
        issueDate: arr[1],
        number: arr[2],
        TotalWithoutTax: arr[3],
        TotalWithTax: arr[4],
        status: arr[5],
        entity_id: arr[6]
    }
}

export const invoicesMockDatas: InvoiceSchema[] = invoicesDataMockBase.map((arr) =>
    createInvoiceObject(arr)
)